
import { ChangeDetectionStrategy, Component, HostBinding, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FlooriRadioModule } from '../floori-radio';
import { DialogHeaderComponent } from '../floori-dialog-header';
import { LangDialogData, Language, Languages } from '../../models';
import { TranslationsModule } from '../../modules';
import { FLOORI_DIALOG_DATA, FlooriDialogModule } from '../floori-dialog';

@Component({
    selector: 'floori-lang-dialog',
    standalone: true,
    imports: [
    DialogHeaderComponent,
    TranslationsModule,
    FlooriDialogModule,
    FlooriRadioModule,
    FormsModule
],
    templateUrl: './floori-lang-dialog.component.html',
    styleUrl: './floori-lang-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlooriLangDialogComponent {
    readonly langs: Language[] = [];

    currentLang?: Languages;
    headerTranslationKey = 'changeLanguage';
    selectTranslationKey = 'chooseLanguage';

    @HostBinding('class.floori-lang-dialog') hostClass = true;

    constructor(@Inject(FLOORI_DIALOG_DATA) data: LangDialogData) {
        this.langs = [...data?.langs];
        this.currentLang = data?.currentLang?.code;
        this.headerTranslationKey = data?.headerTranslationKey;
        this.selectTranslationKey = data?.selectTranslationKey;
    }
}
